export default __webpack_public_path__ + "static/media/Hef.25d5397b.png";